import { render } from "./MatchingQuestion.vue?vue&type=template&id=4af3a330&scoped=true"
import script from "./MatchingQuestion.vue?vue&type=script&lang=js"
export * from "./MatchingQuestion.vue?vue&type=script&lang=js"

import "./MatchingQuestion.vue?vue&type=style&index=0&id=4af3a330&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af3a330"]])

export default __exports__